import React, { useState } from 'react';
import CTAKnap, { CTAIkoner } from './ctaknap';
import { seoFAQData } from '../data/faqData';
import './styles/faq.css';

const SEOFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // Schema.org struktureret data for SEO FAQ
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": seoFAQData.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  return (
    <section className="faq-section" id="seo-faq" aria-labelledby="seo-faq-heading">
      {/* Schema.org JSON-LD for SEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      
      <div className="container">
        <div className="faq-header">
          <h2 id="seo-faq-heading" className="faq-title">
            Ofte stillede spørgsmål om SEO
          </h2>
          <p className="faq-subtitle">
            Har du spørgsmål om SEO og hvordan det kan hjælpe din virksomhed? Find svarene her.
          </p>
        </div>

        <div className="faq-content">
          <div className="faq-accordion" role="region" aria-labelledby="seo-faq-heading">
            {seoFAQData.map((item, index) => (
              <div
                key={index}
                className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                itemScope
                itemType="https://schema.org/Question"
              >
                <button
                  className="faq-question"
                  onClick={() => toggleAccordion(index)}
                  aria-expanded={activeIndex === index}
                  aria-controls={`seo-faq-answer-${index}`}
                  id={`seo-faq-question-${index}`}
                >
                  <span itemProp="name">{item.question}</span>
                  <span className="faq-icon" aria-hidden="true">
                    {activeIndex === index ? '−' : '+'}
                  </span>
                </button>
                
                <div
                  id={`seo-faq-answer-${index}`}
                  className="faq-answer"
                  aria-labelledby={`seo-faq-question-${index}`}
                  role="region"
                  itemScope
                  itemType="https://schema.org/Answer"
                >
                  <div className="faq-answer-content">
                    <p itemProp="text">{item.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="faq-cta">
            <h3>Klar til at forbedre din synlighed på Google?</h3>
            <p>Få en gratis SEO-analyse og lær hvordan vi kan hjælpe din virksomhed</p>
            <div className="faq-cta-buttons">
              <CTAKnap 
                variant="primary" 
                size="large"
                href="/kontakt"
                icon={<CTAIkoner.ArrowRight />}
              >
                Få gratis SEO-analyse
              </CTAKnap>
              <CTAKnap 
                variant="outline" 
                size="large"
                href="/priser#seo"
                icon={<CTAIkoner.BarChart />}
              >
                Se SEO priser
              </CTAKnap>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SEOFAQ;